module.exports = __webpack_public_path__ + "ab79f67bcffd1f2fd69949ffb23c6b89.svg";